import { Dump } from "../../types/dump";
import Api from "../api";

export default async function apiGetDump(id: string) {
  return await Api.get<Dump>({
    input: `/api/v1/dump/${id}`,
  });
}
